import "./notfound.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404</h1>
      <i className="fa-solid fa-link-slash fa-2xl"></i>
      <p>The page you're looking for doesn't exist.</p>

      <button onClick={() => (window.location.href = "/")}>Back To Home</button>
    </div>
  );
};

export default NotFound;
